type LocalProgressState = {
  quizSessionState: object;
  codingDrafts: object;
};

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

export const selectPersistedProgressState = <T extends LocalProgressState>(
  state: T
) => ({
  quizSessionState: state.quizSessionState,
  codingDrafts: state.codingDrafts,
});

export const mergePersistedProgressState = <T extends LocalProgressState>(
  persistedState: unknown,
  currentState: T
): T => {
  const persisted = isRecord(persistedState) ? persistedState : {};
  const quizSessionState = isRecord(persisted.quizSessionState)
    ? persisted.quizSessionState
    : currentState.quizSessionState;
  const codingDrafts = isRecord(persisted.codingDrafts)
    ? persisted.codingDrafts
    : currentState.codingDrafts;

  return {
    ...currentState,
    quizSessionState,
    codingDrafts,
  } as T;
};
